import React from "react";
import { BackTop, Row, Spin } from "antd";
import { template, formatTime } from "@reco-m/core";
import { ViewComponent, Banner, Breadcrumbs, HtmlContent } from "@reco-w/core-ui";
import { Namespaces, informationModel } from "@reco-w/information-models";

export namespace InformationDetails {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, informationModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.information;


        public get isCase(): boolean {
            return !!this.props.match?.params.type;
        }

        componentMount() {
            window.scroll(0, 0);
        }
        componentDidMount() {
            // this.dispatch("input", { tabsIndex: 0 })
            this.dispatch("get", this.props.match?.params.id);
        }
        componentWillUnmount(): void {
            this.dispatch("input", { article: 0 })
        }

        renderBody() {
            const { state } = this.props, article = state!.article;
            const breadcrumbList = [
                { router: "", name: this.isCase ? '案例展示' : ((article?.tagNames || '').split(',')[0] || '').replace('集团官网-', '') || '最新资讯' },
            ]

            return (
                <>
                    <div className="content infor-content">
                        <Banner.Component extraClass="default" bimg="assets/images/guanw/xwzx-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">{this.isCase ? "案例展示" :
                                    ((article?.tagNames || '').split(',')[0] || '').replace('集团官网-', '') || '最新资讯'}</div>
                            </div>}
                        />
                        <div className="crumbs-box">
                            <div className="container">
                                <Breadcrumbs.Component breadcrumbList={breadcrumbList} />
                            </div>
                        </div>
                        <div className="container">
                            <div className="write-box">
                                {article ? <>
                                    <div className="write-box-top">
                                        <div className="write-box-title">{article.title}</div>
                                        <Row className="mt25" align="top" justify="space-between">
                                            <div className="size-14">发布时间：<span className="primary-color">{formatTime(article.publishTime, 'yyyy.MM.dd')}</span></div>
                                            <div className="size-14">浏览：<span className="primary-color">{article.viewCount || 0}</span></div>
                                        </Row>
                                    </div>
                                    <div className="write-box-content">
                                        <HtmlContent.Component html={article.content}></HtmlContent.Component>
                                    </div>
                                </> : <Spin style={{ 'height': '507px', padding: '250px 50%' }}></Spin>}

                            </div>
                        </div>
                    </div>

                    <div className="scoll-top">
                        <BackTop visibilityHeight={50} />
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.information]);
}
